import { css } from '@emotion/react';

export const container = css`
  position: relative;
`;

export const carousel = css`
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 44px 8px 16px;
  background-color: var(--gray50);

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    background-color: var(--gray100);
  }

  li {
    display: flex;
    align-items: center;
    width: fit-content;
    height: auto;
    min-height: 32px;
    white-space: nowrap;
    background-color: var(--white);
    border: 1px solid var(--primary);
    border-radius: 10px;

    button {
      min-height: 32px;
    }
  }

  @media screen and (max-width: 768px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    li {
      width: auto;
    }
  }
`;

export const more = css`
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  width: 44px;
  height: 100%;
  background: var(--gray50);

  &::after {
    position: absolute;
    top: 0;
    right: 44px;
    display: block;
    min-width: 24px;
    height: 100%;
    content: '';
    background: linear-gradient(to left, var(--gray50), rgba(249, 249, 249, 0));
  }

  .oksoon-icon {
    path {
      stroke: var(--gray500);
    }
  }
`;

export const bottomsheet = css`
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 52px;
    padding: 0 16px;

    & > span {
      position: relative;
      flex: 1 1 auto;
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      color: var(--gray800);
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;

      .oksoon-icon {
        path {
          stroke: var(--gray500);
        }
      }
    }
  }

  ul {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 12px 16px 16px;
    background-color: var(--white);

    li {
      overflow-x: auto;
      overflow-y: hidden;
      background-color: var(--white);
      border: 1px solid var(--primary);
      border-radius: 10px;

      button {
        padding: 6px 10px;
        text-align: left;
      }
    }
  }
`;
